module.exports = __webpack_public_path__ + "static/media/ph.12f36eed.svg";